import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installDebugLogGlobals } from './lib/debugLog';
import './lib/auth'; // registers Cognito token refresher for API 401 retries
import './styles.css';
import './pulse-reference.css';

installDebugLogGlobals();
createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
